<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('nav.teams')"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="$t('team.createBreadcrumb')"
      :title="$t('team.createBreadcrumb')"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSend"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>

          <template v-if="admin">
            <p class="form-create__label">Team Lead ID</p>
            <div class="input-container">
              <InputText
                :set-value="formDataToSend"
                :id="'lead_id'"
                :label="'lead_id'"
                :type="'text'"
                :placeholder="'team lead id'"
                :error-messages="validationErrors['leadId']"
                isBordered
              />
            </div>
          </template>
          <template v-else>
            <Notification :error-messages="validationErrors['leadId']" />
          </template>

          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import userApi from "~/api/user";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import Notification from "~/components/molecules/Notification.vue";

export default {
  name: "TeamCreate",
  metaInfo: {
    title: "Team Create",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        lead_id: "",
      },
      admin: false,
      team_lead: false,
      bayer: false,
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    Notification,
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.TEAM_LIST.replace(":page", 1);
    },
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }
    }
  },
  methods: {
    handleSubmit() {
      const data = {
        name: this.formDataToSend.name,
      };

      if (this.admin) {
        data.lead_id = this.formDataToSend.lead_id;
      }

      this.$store.dispatch("users/createTeam", data);
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.TEAM_LIST.replace(":page", 1),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
</style>
